import { debounce } from "lodash"
import { useCallback, useEffect, useRef } from "react"

import "./InfiniteLoopScroll.scss"

const InfiniteLoopScroll = ({
  children,
  documentIsReady,
}: $TSMigrationFixMe) => {
  const reference = useRef<HTMLElement>()
  const speed = 100

  const getScrollLeftPosition = (
    element: $TSMigrationFixMe,
    isRightDirection: $TSMigrationFixMe
  ) => {
    const oldPosition = element.scrollLeft
    const newPosition = isRightDirection
      ? oldPosition + speed
      : oldPosition - speed
    const maxScrollLeft = element.scrollWidth - element.clientWidth
    const isMaxRight = maxScrollLeft - element.scrollLeft <= 2
    const isMaxLeft = element.scrollLeft === 0
    const positionMovingRight = isMaxRight ? 0 : newPosition
    const positionMovingLeft = isMaxLeft ? maxScrollLeft : newPosition

    return isRightDirection ? positionMovingRight : positionMovingLeft
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedScrollLeftPosition = useCallback(
    debounce(
      (element, isRightDirection) =>
        getScrollLeftPosition(element, isRightDirection),
      20
    ),
    []
  )

  // @ts-expect-error TS(7030): Not all code paths return a value.
  useEffect(() => {
    const element = reference.current
    let isDown = false
    let startX = 0

    if (element) {
      element.scrollLeft = speed
      const onWheel = (event: $TSMigrationFixMe) => {
        if (event.deltaY === 0) return
        event.preventDefault()
        element.scrollTo({
          left: getScrollLeftPosition(element, event.deltaY > 0),
        })
      }

      const onMouseDown = (event: $TSMigrationFixMe) => {
        isDown = true
        element.classList.add("active")
        startX = event.pageX
        // @ts-expect-error TS(2339): Property 'scrollLeft' does not exist on type 'HTMLE...
        scrollLeft = element?.scrollLeft
      }

      const onMouseLeave = () => {
        isDown = false
        element.classList.remove("active")
      }

      const onMouseUp = () => {
        isDown = false
        element.classList.remove("active")
      }

      const onMouseMove = (event: $TSMigrationFixMe) => {
        if (!isDown) return
        event.preventDefault()
        element.scrollLeft = debouncedScrollLeftPosition(
          element,
          startX > event.pageX
        )
      }

      const onkeyDown = (event: $TSMigrationFixMe) => {
        if (!["ArrowRight", "ArrowLeft"].includes(event.key)) return

        element.scrollLeft = getScrollLeftPosition(
          element,
          event.key === "ArrowRight"
        )
      }

      const eventListeners = [
        { event: "wheel", onEvent: onWheel },
        { event: "mousedown", onEvent: onMouseDown },
        { event: "mouseleave", onEvent: onMouseLeave },
        { event: "mouseup", onEvent: onMouseUp },
        { event: "mousemove", onEvent: onMouseMove },
        { event: "keydown", onEvent: onkeyDown },
      ]

      eventListeners.forEach(({ event, onEvent }) =>
        element.addEventListener(event, onEvent)
      )

      return () => {
        eventListeners.forEach(({ event, onEvent }) =>
          element.removeEventListener(event, onEvent)
        )
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentIsReady])

  return (
    <div
      // @ts-expect-error TS(2322): Type 'MutableRefObject<undefined>' is not assignab...
      ref={reference}
      className='infinite-scroll-container d-flex mt-3'
      tabIndex={-1}
    >
      {children}
    </div>
  )
}

export default InfiniteLoopScroll
